import React, { useState } from "react";
import "./history-selling.styles.scss";

import SellingHistoryTable from "../selling-history-table/selling-history-table.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const HistorySelling = () => {
  const [searchValue, setSearchValue] = useState("");

  const handleChange = (event) => {
    setSearchValue(event.target.value);
  };

  return (
    <div className="history-selling-container">
      <div className="search-container">
        <input placeholder="Search name, order no." onChange={handleChange} />
        <FontAwesomeIcon icon={["fa", "search"]} color="#3a4b3c" />
      </div>
      <SellingHistoryTable searchValue={searchValue} />
    </div>
  );
};
